import {useNavigate, useParams} from 'react-router-dom'
// import {unityProviderStore} from '../../UnityLoader/unity.provider.store'
import {globalStore} from '../../../global.store'
import {isMobile} from 'react-device-detect'
import {cardsblockStore} from '../../cardsblock/cardsblock.store'

export function useRoomNavigation(
    room: any,
    hoverCardHandler: (id: string) => void,
) {
    const navigate = useNavigate()
    const {category} = useParams()

    const openRoomHandler = () => {
        if (isMobile) {
            return cardsblockStore.setOpenInAppData({
                id: room?.id,
                previewImage: room?.previewImage || room.logo,
                roomName: room?.name,
            })
        } else {
            return navigate(`/room/${room?.id}`)
        }
    }

    const openCopiaHandler = () => {
        const navigateTo = () => {
            if(category === 'constructors') {
                return navigate(`/copia/${category}/${room?.id}/details`)
            }

            navigate(`/copia/${category}/${room?.id}`)
        }

        if (!globalStore.isLogin) {
            globalStore.createGuestUser(navigateTo)
        } else {
            navigateTo()
        }
    }

    return {openRoomHandler, openCopiaHandler}
}
